import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from './ui/button';
import { Eraser } from '@phosphor-icons/react';

export function SignaturePad({ onSave, onCancel, initialSignature = null, width = 500, height = 200 }) {
  const sigRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(!initialSignature);

  const handleClear = () => {
    sigRef.current?.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (sigRef.current?.isEmpty()) return;
    // Use toDataURL directly to avoid trim_canvas module issue
    const dataUrl = sigRef.current.toDataURL('image/png');
    onSave(dataUrl);
  };

  return (
    <div className="space-y-3">
      <div className="border-2 border-dashed border-[#E8E6E1] rounded-lg overflow-hidden bg-white" data-testid="signature-canvas-container">
        <SignatureCanvas
          ref={sigRef}
          penColor="#1A2421"
          canvasProps={{
            width,
            height,
            className: 'w-full',
            style: { width: '100%', height: `${height}px` },
          }}
          onBegin={() => setIsEmpty(false)}
        />
      </div>
      <div className="flex items-center justify-between">
        <Button variant="ghost" size="sm" onClick={handleClear} className="text-[#5E6D66]" data-testid="signature-clear-btn">
          <Eraser size={16} className="mr-1" /> Effacer
        </Button>
        <div className="flex gap-2">
          {onCancel && (
            <Button variant="outline" size="sm" onClick={onCancel}>Annuler</Button>
          )}
          <Button size="sm" onClick={handleSave} disabled={isEmpty} className="bg-[#2D5A4C] hover:bg-[#1E4136]" data-testid="signature-save-btn">
            Enregistrer la signature
          </Button>
        </div>
      </div>
    </div>
  );
}
